import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "./ApiUtils";

const employeeMigrationApiUrl = `${baseApiUrl}/api/EmployeeMigration`;


export async function migrate(migrationData) {
    return await httpRequest(postMigrate.bind(this, migrationData));
}

async function postMigrate(migrationData) {
    let config = getHttpHeaders();
    return await axios.post(`${employeeMigrationApiUrl}`, migrationData, config);
}